import { Receipt } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import { FEATURE_PAYSLIPS } from "../../utils/UserAccessControlUtils";
import PayslipDirectoryPage from "./pages/PayslipDirectoryPage";
import PayslipIssuesPage from "./pages/PayslipIssuesPage";

const PayslipRouter: NavigationLinkProps[] = [
  {
    id: "bc5883cc-e1e2-4d62-aaa5-0c88e3bf0500",
    title: "Payslips",
    description: "",
    path: "/payslips",
    auth: true,
    sidebar: true,
    secondarySidebar: false,
    icon: Receipt,
    component: PayslipDirectoryPage,
    requiredFeature: FEATURE_PAYSLIPS,
    requiredPermissions: ["ANY"],
  },
  {
    id: "bc5883cc-4d62-e1e2-aaa5-0c88e3bf0500",
    title: "Payslips",
    description: "",
    path: "/payslips/:id/errors",
    auth: true,
    sidebar: false,
    secondarySidebar: false,
    component: PayslipIssuesPage,
    requiredFeature: FEATURE_PAYSLIPS,
    requiredPermissions: ["ANY"],
  },
];

export default PayslipRouter;
